module.exports = __webpack_public_path__ + "fonts/NanumSquareRoundL.4aa4e57.woff2";